import React from "react";
import { Container, Card } from "react-bootstrap";
import logonew from "../../assets/img/logo.png";

export default function Appdetails() {
  return (
    <>
      <section id="appdetials" className="margin-bottom-88">
        <Container fluid>
          <div className="detailsapplication">
            <div className="bg-img">
              <img src={logonew} />
            </div>
          </div>

          <div className="appdetails-page">
            <div className="detailscard d-flex justify-content-between align-items-center">
              <h6>TM Application :</h6>
              <p>369852114751</p>
            </div>
            <div className="detailscard d-flex justify-content-between align-items-center">
              <h6>ARN Number:</h6>
              <p>369852114751</p>
            </div>
            <div className="detailscard d-flex justify-content-between align-items-center">
              <h6>Provisional ID:</h6>
              <p>369852114751</p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}
